import React, { useContext } from 'react';
import { ContractStatus } from '@indigo-ag/schema';

import i18next from 'core/i18n';
import {
  DocumentsValidationAvailableDecisions,
  DocumentsValidationDecision
} from '../../DocumentsValidationDecisions/DocumentsValidationDecisions';
import { CollateralFormalizationContext } from '../../../CollateralAnalysis/CollateralFormalization/CollateralFormalization';
import { utils } from 'shared';

interface DocumentsValidationLuchesiDecisionsProps {
  hasDocuments: boolean;
}

export const DocumentsValidationLuchesiDecisions: React.FunctionComponent<DocumentsValidationLuchesiDecisionsProps> = ({
  hasDocuments
}) => {
  /**
   * Collateral Context
   */
  const { updatePhase3 } = useContext(CollateralFormalizationContext);

  const confirmDecision = (contractStatus: ContractStatus) => {
    return (reviewNotes: string) => {
      return updatePhase3({
        contractStatus,
        signedDocumentsReviewNotes: reviewNotes
      });
    };
  };

  const createAmendmentWithoutApproval = (contractStatus: ContractStatus) => {
    return (notes: string) => {
      return updatePhase3({
        contractStatus,
        amendmentCreationNotes: notes
      });
    };
  };

  const getAvailableDecisions = () => {
    const availableDecisions: DocumentsValidationAvailableDecisions = {
      CREATE_AMENDMENT_WITHOUT_APPROVAL: {
        descriptionMessage: utils.text.firstLetterUppercase(
          i18next.t('luchesiCreatingAmendmentWithoutApprovalMessage')
        ),
        successMessage: utils.text.firstLetterUppercase(
          i18next.t('luchesiCreateAmendmentWithoutApprovalSuccessMessage')
        ),
        onConfirmAction: createAmendmentWithoutApproval(ContractStatus.CREATING_AMENDMENT)
      },
      SEND_TO_CREDIT_TEAM: {
        descriptionMessage: i18next.t('luchesiSendingToCreditTeamMessage'),
        successMessage: i18next.t('luchesiSentToCreditTeamSuccessMessage'),
        onConfirmAction: confirmDecision(ContractStatus.SIGNED_DOCUMENTS_SENT_TO_CREDIT_TEAM)
      }
    };

    if (hasDocuments) {
      availableDecisions['VALIDATE'] = {
        descriptionMessage: i18next.t('luchesiValidatingMessage'),
        successMessage: i18next.t('luchesiValidateSuccessMessage'),
        onConfirmAction: confirmDecision(ContractStatus.SIGNED_DOCUMENTS_APPROVED)
      };
    }

    return availableDecisions;
  };

  return <DocumentsValidationDecision availableDecisions={getAvailableDecisions()} />;
};
